import { Component } from '@angular/core';
import {  NavParams, ToastController, ViewController } from 'ionic-angular';
import { TournamentService } from '../../../services/tournament.service';
import { SportAlgoUtils } from '../../../services/sport.algo';

@Component({
  selector: 'edit-pre-round',
  templateUrl: 'edit-pre-round.html',
})
export class ResultEditPreRoundPage {
  roundIndex: any;
  groupIndex: any;
  pareIndex: any;
  activePlan: any;
  results = ["0", "0"];
  points =  ["0", "0"];
  changeDetector: boolean = false;

  constructor(
    private navParams: NavParams,
    private toastCtrl: ToastController,
    private viewCtrl: ViewController,
    public gs: TournamentService
    ) { }

  ionViewDidLoad() {
    this.roundIndex = this.navParams.get('roundIndex');
    this.groupIndex = this.navParams.get('groupIndex');
    this.pareIndex = this.navParams.get('pareIndex');
    this.activePlan = this.navParams.get('activePlan');
    this.results = this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].results.split('-');
    this.points = this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].points.split('-')
  }

  onChangeTeam(index){
    this.toastCtrl.create({
      duration: 5000,
      position: 'top',
    }).present();
  }

  onSetWinner(winnerIndex: number){
    this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].winner = winnerIndex;
    this.changeDetector = true;
    this.gs.save();
  }
  
  onSave(){
    this.gs.save();
  }

  onResultChange(index: number, value: any){
    value = Number(value);
    if(value >= 0){
      let winner = this.getWinner();    
      this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].team1.points = this.getMultiplicator(winner, 1);
      this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].team2.points = this.getMultiplicator(winner, 2);
      this.onPointsChange(winner - 1);
    }
  }

  onPointsChange(winner){
    this.onSetWinner(winner);
  }

  getWinner(){
    if(this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].team1.results > this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].team2.results){
      return 1;
    }else if(this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].team1.results < this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].team2.results){
      return 2;
    }else{
      return 0;
    }
  }

  teamClick(winnerIndex: number){
    this.points[winnerIndex] = this.gs.counters.winScore + "";
    this.onSetWinner(winnerIndex);
  }

  getMultiplicator(winner, team){
   if(winner == 0) return this.gs.counters.tieScore;
   
    if(team == 1){
      return (winner == 1)?  this.gs.counters.winScore: this.gs.counters.lossScore; 
    }else if(team == 2){
      return (winner == 2)?  this.gs.counters.winScore: this.gs.counters.lossScore; 
    }
  }

  onClose(){
    this.update();
    this.viewCtrl.dismiss();
  }

  update(){
    let team1Id =  this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].team1.id;
    let team2Id =  this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].team2.id;
    let arr1Index = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === team1Id);
    let arr2Index = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === team2Id);
    this.gs.planList[this.activePlan].teams[arr1Index].points += this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].team1.points;      
    this.gs.planList[this.activePlan].teams[arr2Index].points += this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].team2.points;      
    this.gs.planList[this.activePlan].teams[arr1Index].results += this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].team1.results;      
    this.gs.planList[this.activePlan].teams[arr2Index].results += this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex].team2.results;      
    this.gs.save();
    this.gs.saveGamePair(this.gs.planList[this.activePlan].gameTable[this.roundIndex][this.groupIndex][this.pareIndex]).then(() => {
      this.gs.loadTou(this.gs.planList[this.activePlan].id).then(plan =>{
        this.gs.planList[this.activePlan] = plan;
      });
    });
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/edits/pre-round/edit-pre-round.ts